(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const reveal = (element) => {
    element.classList.add('is-cdesign-revealed');
  };

  const prepare = (root = document) => {
    const elements = [...root.querySelectorAll('[data-cdesign-reveal]')].filter(
      (element) => element.dataset.cdesignRevealReady !== 'true'
    );

    if (!elements.length) return;

    elements.forEach((element) => {
      element.dataset.cdesignRevealReady = 'true';
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      elements.forEach(reveal);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08,
      }
    );

    elements.forEach((element) => observer.observe(element));
  };

  prepare();
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();
